import Snap from "Snap.svg/dist/snap.svg";
import { StatusService } from "external-services/status-service";
import moment from 'moment';
import TagsService from "external-services/tags-service";
import { StatusCharacterType } from "shared-types/index"

const NS = 'PlanBookingService';

export default function PlanBookingService(SnapConst, SnapService, PlanConst, Group, $filter, $rootScope) {
  "ngInject";

  function Booking(s, table, model, currentTime, defaultDuration, overdueMinutes, overrideCapacity, companyNameFirst) {
    this.s = s;
    this.table = table;
    this.model = model;
    this.model.type = 'booking';
    this.meta = Booking.getMetadata(table, model, currentTime, defaultDuration, overdueMinutes, overrideCapacity, companyNameFirst);

    this.listeners = [];
    var _self = this;
    this.planDestroyListener = $rootScope.$on('plan-destroy', function () {
      _self.destroy();
    });

    window.renderedBookings.total++;
  }

  Booking.prototype = {

    destroy: function () {
      _.each(this.listeners, function (listener) {
        listener();
      });
      this.planDestroyListener();
      if (this.detailBooking) {
        this.detailBooking.getSGroup().remove();
      }
      if (this.tableBooking) {
        this.tableBooking.getSGroup().remove();
      }
    },

    getDetailBooking: function () {
      if (this.detailBooking) {
        return this.detailBooking;
      }
      var g = new Group(this.s, 'booking', Booking.Sizes.Details);
      g.buildRootElement();
      g.getSGroup().addClass('detail');
      var status = this._buildStatus();
      var start = this._buildStartTime();
      var customer = this._buildCustomer(false);
      var quantity = this._buildPeople();
      var joined = this._buildJoined();
      var name = this._buildName(false, true);
      var left = this.s.rect(0, 0, 3, Booking.Sizes.Details.h).addClass('left');
      var right = this.s.rect(0, 0, 1, Booking.Sizes.Details.h).addClass('right');
      g.addElement(status, 'status');
      g.addElement(start, 'start');
      g.addElement(customer, 'customer');
      g.addElement(quantity, 'quantity');
      if (joined != null) {
        g.addElement(joined, 'joined');
      }
      g.addElement(name, 'name');
      g.addElement(left, 'left');
      g.addElement(right, 'right');
      SnapService.place(status, 5, 5);
      SnapService.place(start, 30, 2);
      SnapService.place(customer, 30, 17);
      if (joined != null) {
        SnapService.place(joined, Booking.Sizes.Details.w - 14, 7);
      }
      SnapService.place(quantity, Booking.Sizes.Details.w - SnapService.calcBBox(quantity).width - SnapService.calcBBox(name).width - 18, 6);
      SnapService.place(name, Booking.Sizes.Details.w - SnapService.calcBBox(name).width - 13, 6);
      SnapService.place(left, 0, 0);
      SnapService.place(right, Booking.Sizes.Details.w - 1, 0);

      var tagsMaxWidth = Booking.Sizes.Details.w - (SnapService.calcBBox(start).width + 40) - (SnapService.calcBBox(quantity).width + SnapService.calcBBox(name).width + 20);
      var tags = this._buildTags(tagsMaxWidth);
      if (tags != null) {
        g.addElement(tags, 'tags');
        SnapService.place(tags, SnapService.calcBBox(start).width + 40, 2);
      }
      this.detailBooking = g;
      return g;
    },

    getTableBooking: function () {
      if (this.tableBooking) {
        return this.tableBooking;
      }
      window.renderedBookings.added++;
      var size = Booking.Sizes.Body.w;
      var g = new Group(this.s, 'booking', {
        w: size,
        h: size
      });
      g.buildRootElement();

      if (this.meta.joinedType === Booking.JoinedStatuses.Slave) {
        var icon = this._buildJoined(true);
        var iconSize = icon.data().size;
        var desc = this.s.text(0, 0, 'JOINED').addClass('joinedlabel');
        var master = this.s.text(0, 0, 'T' + this.meta.masterTable.name).addClass('bold joinedTableName');
        g.addElement(icon, 'icon');
        g.addElement(desc, 'desc');
        g.addElement(master, 'master');
        var space = 0;
        SnapService.setEllipsis(master, size - iconSize.w - space);
        SnapService.applyEllipsis(master);
        SnapService.place(desc, (size - SnapService.getTextWidth(desc)) / 2, 16);
        var width = iconSize.w + SnapService.getTextWidth(master) + space;
        var delta = (size - width) / 2;
        SnapService.place(icon, delta, 31);
        SnapService.place(master, delta + iconSize.w + space, 27);
      } else if (this.meta.type === Booking.Statuses.Current || this.meta.type === Booking.Statuses.Next) {
        var iconsRow = this._buildIconsRow();
        g.addElement(iconsRow, 'iconsRow');
        var tableRow = this._buildTableRow();
        g.addElement(tableRow, 'tableRow');
        SnapService.applyEllipsis(tableRow);

        var customer = this._buildCustomer(this.meta.type === Booking.Statuses.Current, Booking.Sizes.Body.w);
        g.addElement(customer, 'customer');
        SnapService.applyEllipsis(customer);
        var height = 0;
        if (this.meta.type === Booking.Statuses.Current) {
          var peopleRow = this._buildPeople();
          g.addElement(peopleRow, 'peopleRow');
          g.getSGroup().addClass('current');
          var progress = this._buildProgress();
          g.addElement(progress, 'progress');
          //Place elements
          SnapService.place(iconsRow, (size - SnapService.getShape(iconsRow).w) / 2, 0);
          height += 15;
          SnapService.place(tableRow, 0, height);
          SnapService.place(peopleRow, size - SnapService.getShape(peopleRow).w, height + 4);
          height += 16;
          SnapService.place(progress, 0, height);
          height += SnapService.getElement(progress).data().size.h + 2;
          SnapService.place(customer, 0, height);
        } else if (this.meta.type === Booking.Statuses.Next) {
          g.getSGroup().addClass('next');
          var comingIn = this._buildComingIn();
          var comingInSize = SnapService.getElement(comingIn).data().size;
          g.addElement(comingIn, 'comingIn');
          //Place elements
          SnapService.place(comingIn, (size - comingInSize.w) / 2, 0);
          height += comingInSize.h + 2;
          SnapService.place(iconsRow, (size - SnapService.getShape(iconsRow).w) / 2, height);
          height += SnapService.getShape(iconsRow).h + 2;
          SnapService.place(tableRow, 0, height);
          SnapService.place(customer, 0, size - SnapService.getShape(customer).h + 1);
        }
      }
      this.tableBooking = g;
      return this.tableBooking;
    },

    refreshTableBooking: function () {
      if (this.tableBooking) {
        var old;
        window.renderedBookings.refreshed++;
        if (this.meta.type === Booking.Statuses.Current) {
          old = this.tableBooking.getElement('progress');
          if (old) {
            var w = Booking.Sizes.Body.w / 100 * this.meta.donePercentage;
            this.tableBooking.elements['progress'].getElement('elapsed').attr('width', w); // jshint ignore:line
          }
        }
        if (this.meta.type === Booking.Statuses.Next) {
          old = this.tableBooking.getElement('comingIn');
          if (old) {
            var size = Booking.Sizes.Body.w;
            var comingIn = this._buildComingIn();
            var comingInSize = SnapService.getElement(comingIn).data().size;
            this.tableBooking.removeElement('comingIn');
            this.tableBooking.addElement(comingIn, 'comingIn');
            SnapService.place(comingIn, (size - comingInSize.w) / 2, 0);
          }
        }
      }
    },

    //Joined, Status and Locked icons
    _buildIconsRow: function () {
      var joined = this._buildJoined();
      var status = this._buildStatus();
      var locked = this._buildLocked();
      var g = new Group(this.s, 'icons-row', {
        w: Booking.Sizes.Body.w,
        h: 15
      });
      if (joined) {
        g.addElement(joined, 'joined');
        SnapService.place(joined, 2, 2);
      }
      g.addElement(status, 'status');
      SnapService.place(status, (Booking.Sizes.Body.w - 15) / 2, 1);
      if (locked) {
        g.addElement(locked, 'locked');
        SnapService.place(locked, Booking.Sizes.Body.w - 14, 2);
      }
      return g;
    },

    //Table name and people count
    _buildTableRow: function () {
      var tableName = this._buildName();
      var g = new Group(this.s, 'table-row', {
        w: Booking.Sizes.Body.w,
        h: 20
      });
      g.addElement(tableName, 'table');
      SnapService.place(tableName, 0, 0);
      SnapService.setEllipsis(tableName, g.shape.w);
      return g;
    },

    _buildComingIn: function () {
      var g = new Group(this.s, 'comingIn');
      var content = this.s.text(0, 0, 'P' + this.model.people + ' in ' + this.meta.beforeStart + 'm').addClass('booking-font comingIn');
      var size = {
        w: SnapService.getTextWidth(content),
        h: Booking.FontSize
      };
      var line = this.s.rect(0, 0, size.w + 2, 1);
      g.addElement(content, 'content');
      g.addElement(line, 'line');
      SnapService.place(content, 2, 0);
      SnapService.place(line, 0, size.h);
      size.w += 2;
      SnapService.getElement(g).data().size = size;
      return g;
    },

    _buildPeople: function () {
      var g = new Group(this.s, 'people');
      var people = this.s.text(0, 0, 'P' + this.model.people).addClass('people booking-font');
      var totalCapacity = this.meta.overrideCapacity ? this.meta.overrideCapacity : _.reduce(this.model.tables, function (total, table) {
        return total + table.capacity;
      }, 0);
      if (this.model.people > totalCapacity) {
        people.addClass('over-capacity');
      }
      g.addElement(people, 'people');
      return g;
    },

    _buildStatus: function () {
      const _self = this;
      const statusSize = 15;
      const status = new Group(this.s, 'status', {
        w: statusSize,
        h: statusSize
      });
      let circle;

      if (this.model.status.statusColor) {
        circle = this.s.rect(0, 0, statusSize, statusSize, statusSize, statusSize).addClass('circle ' + this.model.status.statusType + ' ' + this.model.status.name).attr({style: `fill: ${this.model.status.statusColor}!important`});
      } else {
        circle = this.s.rect(0, 0, statusSize, statusSize, statusSize, statusSize).addClass('circle ' + this.model.status.statusType + ' ' + this.model.status.name);
      }
      status.addElement(circle, 'circle');

      const {char1, char2} = StatusService.getStatusCodeCharacters(this.model.status, this.model.paymentDetails, this.model.bookingType);

      let text1XPos = char2.text ? 8 : 10.5; // if 2 chars, move more to the left
      if (char2.large) {
        text1XPos = 7; // if 2nd char is large, move more to the left to give space
      }
      const tagText1 = this.s.text(text1XPos, char1.large ? 1 : 3, char1.text)
        .addClass('tag end ' + this.model.status.statusType + (char1.large ? ` largeStatusSymbol${char1.type === StatusCharacterType.typeA ? 'A' : 'B'}` : ''));
      status.addElement(tagText1, 'tagText1');

      let text2XPos = 13;
      if (char1.large) {
        text2XPos = 14; // if char1 is large, move more to the right to give space
      }
      const tagText2 = this.s.text(text2XPos, char2.large ? 1 : 3, char2.text)
        .addClass('tag end ' + this.model.status.statusType + (char2.large ? ` largeStatusSymbol${char2.type === StatusCharacterType.typeA ? 'A' : 'B'}` : ''));
      status.addElement(tagText2, 'tagText1');

      this.listeners.push(SnapService.onClick(status, function (evt) {
        $rootScope.$broadcast('edit-booking-status', evt, _self);
      }, undefined, false, (evt, originalTarget) => {

        // here we tell the parent 'booking' tile to start dragging as if it was clicked directly
        const bookingTile = originalTarget.parent().parent();
        if (bookingTile) {
          SnapService.startDraggingFromEvent(bookingTile, evt, true);
        }
      }));
      return status;
    },

    _buildName: function (showStatus, showJoineds, showCapacity, truncateSize) {
      truncateSize = truncateSize || 15;
      var name = '';
      if (showJoineds) {
        _.each($filter('alphaSortFilter')(this.model.tables, 'name'), function (t) {
          name += 'T' + t.name + ', ';
        });
        name = name.substring(0, name.length - 2);
      } else {
        name = 'T' + this.table.name;
        if (showStatus) {
          name += (this.table.online ? '*' : '');
          name += (this.table.shared ? '^' : '');
          name += (this.table.walkinOnly ? '~' : '');
        }
      }
      if (name.length > truncateSize) {
        name = name.substr(0, truncateSize) + '...';
      }
      return this.s.text(0, 0, name).addClass('booking-font table-name');
    },

    _buildProgress: function () {
      var size = {
        type: SnapConst.Shapes.Rect,
        h: 3,
        w: Booking.Sizes.Body.w
      };
      var progress = new Group(this.s, 'progress', size);
      progress.buildRootElement();
      var elapsed = this.s.rect(0, 0, size.w / 100 * this.meta.donePercentage, size.h).addClass('elapsed');
      progress.addElement(elapsed, 'elapsed');
      SnapService.getElement(progress).data().size = size;
      return progress;
    },

    _buildStartTime: function () {
      return this.s.text(0, 0, moment(this.model.time).format('hh:mmA')).addClass('start');
    },

    /**
     * twoLines are available when rendering a tile booking of type current.
     * Possible render combinations are
     *
     * company
     * f. lastName
     *
     * firstName
     * lastName
     *
     * company, firstName LastName
     *
     * All combination company/name order is subject to setting companyNameFirst
     */
    _buildCustomer: function (twoLines, availableWidth) {
      // this.meta.companyNameFirst
      var g = new Group(this.s, 'customer');
      // Define lines logic
      var nameLines = twoLines && !this.model.company ? 2 : 1;
      var company = this.model.company ? [this.model.company] : [];
      var name = [];
      if (this.model.firstName) {
        name.push((twoLines && this.model.company) ? this.model.firstName.charAt(0) : this.model.firstName);
      }
      if (this.model.lastName) {
        name.push(this.model.lastName);
      }
      if (nameLines === 1) {
        name = [name.join(' ')];
      }
      var labelContent = this.meta.companyNameFirst ? company.concat(name) : name.concat(company);
      labelContent = twoLines ? labelContent : [labelContent.join(', ')];
      // Render lines
      var y = 0;
      _.each(labelContent, function (line, idx) {
        var sLine = this.s.text(0, 0, line).addClass('customer').addClass('booking-font');
        g.addElement(sLine, 'line_' + idx);
        SnapService.place(sLine, 0, y);
        y += 9;
        if (availableWidth) {
          SnapService.setEllipsis(sLine, availableWidth);
        }
      }, this);

      return g;
    },

    _buildTags: function (maxWidth) {
      maxWidth = maxWidth || 180;
      var tags = new Group(this.s, 'tags', {
        type: SnapConst.Shapes.Rect,
        w: maxWidth,
        h: 10
      });
      TagsService.getBookingTags(this.model).then(_.bind(function (data) {
        var tagIcons = data.slice(0, Math.floor(maxWidth / 16));
        if (!_.isEmpty(tagIcons)) {
          var x = 0;
          _.each(tagIcons, function (tag, i) {
            Snap.load("images/tags/" + tag.icon + ".svg", function (res) {
              var img = res.select('svg');
              if (img) {
                // Set root colour
                img.attr({
                  fill: tag.colour ? tag.colour : '#000000',
                  'data-icon': tag.icon
                });
                // Set children colour
                if (tag.colour && img.node && img.node.children) {
                  _.each(img.node.children, function (child) {
                    child.style.stroke = tag.colour;
                  });
                }
                SnapService.getElement(img).attr({
                  x: x,
                  y: 0,
                  width: 14,
                  height: 14
                });
                tags.addElement(img, 'tag' + i);
                x += 16;
              } else {
                console.warn('Tag icon', tag, 'has a incompatible file format!');
              }
            }, this);
          }, this);
        }
      }, this));
      return tags;
    },

    _buildJoined: function (small) {
      if (this.meta.joinedType === Booking.JoinedStatuses.Single) {
        return null;
      } else {
        var size = small ? 9 : 12;
        var icon = this.s.image("images/tags/link-variant.svg", 0, 0, size, size);
        SnapService.rotate(icon, 135);
        icon.data().size = {
          w: size,
          h: size
        };
        return icon;
      }
    },

    _buildLocked: function () {
      return this.model.locked ? this.s.image("images/tags/locked.svg", 0, 0, 12, 12) : null;
    }
  };

  /************************************************************************************************************************
   *************************************************************************************************************************
   STATIC ATTRIBUTES AND FUNCTIONS
   *************************************************************************************************************************
   ************************************************************************************************************************/
  Booking.getMetadata = function (table, model, currentTime, defaultDuration, overdueMinutes, overrideCapacity, companyNameFirst) {
    var m = {
      id: model._id,
      rev: model._rev,
      endTime: moment(model.bookingEnd),
      startTime: moment(model.time),
      type: Booking.Statuses.Done,
      overrideCapacity: overrideCapacity,
      donePercentage: 0,
      isOverdue: false,
      masterTable: null,
      joinedType: Booking.JoinedStatuses.Single,
      companyNameFirst: companyNameFirst
    };

    m.beforeStart = Math.ceil(moment.duration(m.startTime.diff(currentTime)).asMinutes());
    m.afterStart = Math.ceil(moment.duration(currentTime.diff(m.startTime)).asMinutes());
    m.afterEnd = Math.ceil(moment.duration(currentTime.diff(m.endTime)).asMinutes());

    if (m.afterEnd >= 0 || // standard logic
      (m.afterEnd >= -1 && model.status.name === 'Finished') // NBI-2145 force a hide refresh for Finished booking
    ) {
      //Done
      m.type = Booking.Statuses.Done;
      m.donePercentage = 100;
    } else if (m.afterStart >= 0 && m.afterStart <= model.duration) {
      //Current
      m.type = Booking.Statuses.Current;
      m.donePercentage = Booking.getElapsedPercentage(model, currentTime);
      m.isOverdue = Booking.getOverdue(model, currentTime, overdueMinutes);
    } else if (m.beforeStart > 0) {
      if (m.beforeStart < defaultDuration) {
        //Next
        m.type = Booking.Statuses.Next;
      } else {
        //Far
        m.type = Booking.Statuses.Far;
      }
    }

    if (_.size(model.tables) > 1) {
      if (model.primaryTableId) {
        m.masterTable = _.find(model.tables, function (t) {
          return t._id === model.primaryTableId;
        });
      } else {
        m.masterTable = _.min(model.tables, function (t) {
          return t.name;
        });
      }
      m.joinedType = m.masterTable._id === table._id ? Booking.JoinedStatuses.Master : Booking.JoinedStatuses.Slave;
    } else {
      m.joinedType = Booking.JoinedStatuses.Single;
      m.masterTable = model.tables[0];
    }

    return m;
  };

  Booking.getElapsedPercentage = function (model, currentTime) {
    var elapsed = 0;
    var start = new moment(model.time);
    var duration = moment.duration(currentTime.diff(start)).asMinutes();
    if (duration >= 0) {
      if (duration > model.duration) {
        elapsed = 100;
      } else {
        elapsed = 100 / model.duration * duration;
        elapsed = Math.min(Math.max(elapsed, 1), 99);
      }
    }
    return elapsed;
  };

  Booking.getOverdue = function (model, currentTime, overdueMinutes) {
    if (overdueMinutes &&
      _.indexOf(['unconfirmed', 'confirmed'], model.status.statusType) >= 0 &&
      currentTime.isSame(moment(), 'day')) {
      var start = new moment(model.time);
      var startedMins = Math.ceil(moment.duration(currentTime.diff(start)).asMinutes());
      return startedMins >= overdueMinutes;
    }
    return false;
  };

  Booking.checkConflicts = function (bookings, from, to) {
    var statuses = [];
    if (bookings.length >= 2) {
      //Conflicts may happens for 2+ bookings
      _.each(bookings, function (booking) {
        var status = {
          running: false,
          upcoming: false
        };
        if (booking.meta.type !== Booking.Statuses.Done) {
          //Check booking active at current time
          if (booking.meta.type === Booking.Statuses.Current) {
            status.running = true;
          }
          //Check booking active at front/to interval
          //bookingEndTime after current time, bookingTime before to(current time + highlightConflictMins[15mins])
          if (!(moment(booking.model.time).isAfter(to) || moment(booking.model.bookingEnd).isBefore(from))) {
            status.upcoming = true;
          }
        }
        statuses.push(status);
      });
    }
    return statuses;
  };

  Booking.isSameBookingByTime = function (a, b) {
    var result = a.meta.id === b.meta.id &&
      a.meta.rev === b.meta.rev &&
      a.meta.type === b.meta.type &&
      a.meta.isOverdue === b.meta.isOverdue;
    return result;
  };

  Booking.Sizes = {
    Body: {
      w: Math.floor(Math.sqrt(Math.pow(80, 2) / 2)),
      h: Math.floor(Math.sqrt(Math.pow(80, 2) / 2))
    },
    Details: {
      w: 310,
      h: 30
    }
  };

  Booking.FontSize = 10;

  Booking.Duration = 90;

  Booking.Statuses = {
    Done: 'Done', //Past expired
    Current: 'Current', //Ongoing
    Next: 'Next', // Coming within the schedule default duration
    Far: 'Far' // Coming after the schedule default duration
  };

  Booking.JoinedStatuses = {
    Single: 'single', //This booking is assigned to a single table
    Master: 'master', //This bookig is assigned to more tables, current table is the main one
    Slave: 'slave' //This bookig is assigned to more tables, current table is a secondary one
  };

  return Booking;
}
